var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommandLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(18.223124, 0, 0, 19.656101, 1.955419, -31.124758)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.322,1.947H1.949C0.869,1.947,0,2.818,0,3.898v19.477c0,1.074,0.869,1.947,1.949,1.947h23.373 c1.07,0,1.947-0.873,1.947-1.947V3.898C27.27,2.818,26.393,1.947,25.322,1.947z M9.312,3.41c0.537,0,0.973,0.436,0.973,0.975 c0,0.537-0.436,0.973-0.973,0.973c-0.539,0-0.975-0.436-0.975-0.973C8.338,3.845,8.773,3.41,9.312,3.41z M6.33,3.41 c0.537,0,0.975,0.436,0.975,0.975c0,0.537-0.438,0.973-0.975,0.973c-0.539,0-0.975-0.436-0.975-0.973 C5.355,3.845,5.791,3.41,6.33,3.41z M3.406,3.41c0.541,0,0.975,0.436,0.975,0.975c0,0.537-0.434,0.973-0.975,0.973 c-0.535,0-0.971-0.436-0.971-0.973C2.436,3.845,2.871,3.41,3.406,3.41z M25.322,23.375H1.949V6.838h23.373 C25.322,6.838,25.322,23.375,25.322,23.375z",
    style: {
      fill: "rgb(140, 140, 140)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.797,15.566L5.844,20.16v-1.332l7.602-3.781v-0.039l-7.602-3.782V9.894l8.953,4.572V15.566z",
    style: {
      fill: "rgb(140, 140, 140)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.422,14.334v1.232h-4.764v-1.232H21.422z",
    style: {
      fill: "rgb(140, 140, 140)"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(18.223124, 0, 0, 19.656101, 1.955419, -31.124758)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(18.223124, 0, 0, 19.656101, 1.955419, -31.124758)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(18.223124, 0, 0, 19.656101, 1.955419, -31.124758)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(18.223124, 0, 0, 19.656101, 1.955419, -31.124758)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(18.223124, 0, 0, 19.656101, 1.955419, -31.124758)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(18.223124, 0, 0, 19.656101, 1.955419, -31.124758)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(18.223124, 0, 0, 19.656101, 1.955419, -31.124758)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(18.223124, 0, 0, 19.656101, 1.955419, -31.124758)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(18.223124, 0, 0, 19.656101, 1.955419, -31.124758)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(18.223124, 0, 0, 19.656101, 1.955419, -31.124758)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(18.223124, 0, 0, 19.656101, 1.955419, -31.124758)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(18.223124, 0, 0, 19.656101, 1.955419, -31.124758)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(18.223124, 0, 0, 19.656101, 1.955419, -31.124758)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(18.223124, 0, 0, 19.656101, 1.955419, -31.124758)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(18.223124, 0, 0, 19.656101, 1.955419, -31.124758)",
    style: {}
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommandLine);
export default __webpack_public_path__ + "static/media/command-line.a9f80a93ccb03891f27612d03fd27f01.svg";
export { ForwardRef as ReactComponent };